export default __webpack_public_path__ + "static/media/hero_img_mob.bc3a84e2.webp";